<template>
  <div>
    <span>StatsPage</span>
    <div v-for="stat in item" :key="stat.id">
      <div v-if="['int', 'float', 'bool', 'dbm', 'perc', 'trigger'].includes(stat.type)" class="row">
        <label class="col-4 col-md-3">{{ stat.name }}</label>
        <div class="col-8 col-md-9">{{ stat.value }}</div>
      </div>
      <div v-else-if="stat.type === 'wlnk'" class="row" style="width: 50%;">
        <div class="col-12">
          <h2 class="mb-3">{{ stat.name }}</h2>
          <div v-for="(value, key) in stat.value" :key="key" class="row mb-2">
            <label class="col-6 col-md-3">{{ key }}</label>
            <div class="col-6 col-md-9">{{ value }}</div>
          </div>
        </div>
      </div>
      <div v-else-if="['sta', 'wsta'].includes(stat.type)" class="row">
        <div class="col-12">
          <h2 class="mb-3">{{ stat.name }}</h2>
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th class="col-4 col-md-2">Name</th>
                  <th class="col-4 col-md-2">MAC</th>
                  <th class="col-4 col-md-2">IP</th>
                  <th class="col-4 col-md-2">TX</th>
                  <th class="col-4 col-md-2">TXB</th>
                  <th class="col-4 col-md-2">RX</th>
                  <th class="col-4 col-md-2">RXB</th>
                  <th v-if="stat.type === 'wsta'" class="col-4 col-md-2">TX Rate</th>
                  <th v-if="stat.type === 'wsta'" class="col-4 col-md-2">RX Rate</th>
                  <th v-if="stat.type === 'wsta'" class="col-4 col-md-2">RSSI</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="station in stat.value" :key="station.mac">
                  <td class="col-4 col-md-2">{{ station.name }}</td>
                  <td class="col-4 col-md-2">{{ station.mac }}</td>
                  <td class="col-4 col-md-2">{{ station.ip }}</td>
                  <td class="col-4 col-md-2">{{ station.tx }}</td>
                  <td class="col-4 col-md-2">{{ station.txb }}</td>
                  <td class="col-4 col-md-2">{{ station.rx }}</td>
                  <td class="col-4 col-md-2">{{ station.rxb }}</td>
                  <td v-if="stat.type === 'wsta'" class="col-4 col-md-2">{{ station.txrate }}</td>
                  <td v-if="stat.type === 'wsta'" class="col-4 col-md-2">{{ station.rxrate }}</td>
                  <td v-if="stat.type === 'wsta'" class="col-4 col-md-2">{{ station.rssi }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { onMounted } from 'vue';

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  name: 'StatsPage',
  emits: ['load-finished'], 
  setup(props, { emit }) {
    onMounted(() => {
      setTimeout(() => {
        console.log("emit load-finished");
        emit('load-finished');
      }, 2000); 
    });

    // Your component logic here

    return {};
  },
};
</script>